import { render } from "./ContactoForm.vue?vue&type=template&id=d5a6fae6"
import script from "./ContactoForm.vue?vue&type=script&lang=js"
export * from "./ContactoForm.vue?vue&type=script&lang=js"

import "./ContactoForm.vue?vue&type=style&index=0&id=d5a6fae6&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__